(function(){
var P=window.COLO_P;if(!P)return;
function $(s,r){return (r||document).querySelector(s)}
function money(c){return '$'+(c/100).toFixed(2)}
function curId(){var i=$('form[action*="/cart/add"] input[name=id]');return i&&P.v[i.value]?i.value:Object.keys(P.v)[0]}
var LIMIT=10000,cartTotal=0,qtySel=1;
function fmt(d){return d.toLocaleDateString('en-US',{weekday:'short',month:'short',day:'numeric'})}
function addBiz(n){var d=new Date();while(n>0){d.setDate(d.getDate()+1);var w=d.getDay();if(w!==0&&w!==6)n--}return d}
function render(){
  var prod=$('.product');if(!prod||!matchMedia('(min-width:990px)').matches)return;
  var bx=$('.colo-buybox');if(!bx){bx=document.createElement('div');bx.className='colo-buybox';prod.appendChild(bx)}
  var v=P.v[curId()];if(!v)return;
  var price=v[0],cmp=v[3]||0,stock=v[1],tracked=v[2]===1;
  var out=tracked&&stock<=0;
  var max=tracked?Math.min(10,Math.max(stock,1)):10;if(qtySel>max)qtySel=max;
  var h='<div class="colo-bb__price">'+money(price);
  if(cmp>=price*2){h+='<s>'+money(cmp)+'</s><span class="colo-bb__off">-'+Math.round((1-price/cmp)*100)+'%</span>'}
  h+='</div>';
  var total=cartTotal+price*qtySel,rem=LIMIT-total;
  h+='<p class="colo-bb__ship">'+(rem>0?'<b>FREE shipping</b> on orders over $100. Add '+money(rem)+' more to qualify.':'<b>This order qualifies for FREE shipping.</b>')+'</p>';
  h+='<p class="colo-bb__eta">Estimated delivery <b>'+fmt(addBiz(5))+' – '+fmt(addBiz(9))+'</b></p>';
  var sc='colo-bb__stock',st='In stock';
  if(out){sc+=' is-out';st='Out of stock'}else if(tracked&&stock<=10){sc+=' is-low';st='Only '+stock+' left in stock – order soon'}
  h+='<div class="'+sc+'">'+st+'</div>';
  if(!out){h+='<label class="colo-bb__qty">Qty <select>';for(var i=1;i<=max;i++)h+='<option value="'+i+'"'+(i===qtySel?' selected':'')+'>'+i+'</option>';h+='</select></label>'}
  h+='<button type="button" class="colo-bb__btn colo-bb__add"'+(out?' disabled':'')+'>Add to cart</button>';
  h+='<button type="button" class="colo-bb__btn colo-bb__buy"'+(out?' disabled':'')+'>Buy now</button>';
  h+='<dl class="colo-bb__meta"><dt>Ships from</dt><dd>COLO Outlet</dd><dt>Sold by</dt><dd>COLO Outlet</dd><dt>Returns</dt><dd>15-day returns</dd><dt>Payment</dt><dd>Secure transaction</dd></dl>';
  if(bx.getAttribute('data-k')===h)return;bx.setAttribute('data-k',h);bx.innerHTML=h;
  var sel=$('select',bx);if(sel)sel.addEventListener('change',function(){qtySel=+sel.value;render()});
  $('.colo-bb__add',bx).addEventListener('click',function(){
    var qi=$('.product-form__quantity input');if(qi){qi.value=qtySel;qi.dispatchEvent(new Event('change',{bubbles:true}))}
    var s=$('.product-form__submit');if(s&&!s.disabled)s.click();
  });
  $('.colo-bb__buy',bx).addEventListener('click',async function(){
    this.disabled=true;this.textContent='Redirecting…';
    try{await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:+curId(),quantity:qtySel})});location.href='/checkout'}catch(e){this.disabled=false;this.textContent='Buy now'}
  });
}
async function fbt(){
  if($('.colo-fbt'))return;
  var cur=P.v[curId()];if(!cur||(cur[2]===1&&cur[1]<=0))return;
  var pid=P.pid;if(!pid)return;
  var list=[];
  try{
    for(var k=0;k<2&&list.length<2;k++){
      var j=await (await fetch('/recommendations/products.json?product_id='+pid+'&limit=8&intent='+(k?'related':'complementary'))).json();
      (j.products||[]).forEach(function(p){if(list.length<2&&p.available!==false&&p.variants&&p.variants.length===1&&!list.some(function(x){return x.id===p.id}))list.push(p)});
    }
  }catch(e){}
  if(!list.length)return;
  var items=[{id:+curId(),t:P.title,p:cur[0],img:P.img,url:location.pathname,self:true}].concat(list.map(function(p){return{id:p.variants[0].id,t:p.title,p:p.price,img:p.featured_image,url:p.url}}));
  var w=document.createElement('div');w.className='colo-fbt';
  var box=document.createElement('div');box.className='colo-fbt__box';
  var h2=document.createElement('h2');h2.textContent='Pair it with';box.appendChild(h2);
  var row=document.createElement('div');row.className='colo-fbt__row';
  var sum=document.createElement('div');sum.className='colo-fbt__sum';
  var tot=document.createElement('div');tot.className='colo-fbt__total';
  var go=document.createElement('button');go.type='button';go.className='colo-fbt__go';
  var boxes=[];
  items.forEach(function(it,i){
    if(i){var pl=document.createElement('span');pl.className='colo-fbt__plus';pl.textContent='+';row.appendChild(pl)}
    var d=document.createElement('div');d.className='colo-fbt__item';
    var a=document.createElement('a');a.className='colo-fbt__img';a.href=it.url;
    if(it.img){var im=document.createElement('img');im.src=String(it.img).replace(/(\.[a-z]+)(\?|$)/i,'_300x300$1$2');im.alt='';a.appendChild(im)}
    var lb=document.createElement('label');var cb=document.createElement('input');cb.type='checkbox';cb.checked=true;if(it.self)cb.disabled=true;cb.addEventListener('change',calc);
    var sp=document.createElement('span');sp.textContent=(it.self?'This item: ':'')+it.t;lb.appendChild(cb);lb.appendChild(sp);
    var pr=document.createElement('b');pr.textContent=money(it.p);
    d.appendChild(a);d.appendChild(lb);d.appendChild(pr);row.appendChild(d);boxes.push({cb:cb,it:it});
  });
  function calc(){var sel=boxes.filter(function(b){return b.cb.checked});var t=sel.reduce(function(s,b){return s+b.it.p},0);tot.innerHTML='';tot.appendChild(document.createTextNode('Total price: '));var b=document.createElement('b');b.textContent=money(t);tot.appendChild(b);go.textContent='Add '+(sel.length===1?'item':'all '+sel.length+' items')+' to cart';go.disabled=false}
  go.addEventListener('click',async function(){
    var sel=boxes.filter(function(b){return b.cb.checked}).map(function(b){return{id:b.it.id,quantity:1}});
    go.disabled=true;go.textContent='Adding…';
    var drawer=$('cart-drawer');var body={items:sel};
    try{
      if(drawer&&drawer.getSectionsToRender){body.sections=drawer.getSectionsToRender().map(function(s){return s.id});body.sections_url=location.pathname}
      var r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)});var st=await r.json();
      if(st.sections&&drawer){drawer.renderContents(st)}else{location.href='/cart'}
      calc();
    }catch(e){calc()}
  });
  sum.appendChild(tot);sum.appendChild(go);row.appendChild(sum);box.appendChild(row);w.appendChild(box);
  calc();
  var sec=$('main > .shopify-section');if(sec)sec.after(w);w.classList.add('is-on');
}
async function init(){
  try{var c=await (await fetch('/cart.js')).json();cartTotal=c.total_price||0}catch(e){}
  render();fbt();
}
var tm;function upd(){clearTimeout(tm);tm=setTimeout(render,250)}
document.addEventListener('DOMContentLoaded',function(){
  init();
  new MutationObserver(function(m){
    for(var i=0;i<m.length;i++){var t=m[i].target;if(t.closest&&t.closest('.colo-buybox,.colo-fbt,.colo-sticky,.colo-rv'))continue;
      var ch=[].slice.call(m[i].addedNodes).concat([].slice.call(m[i].removedNodes));
      if(ch.length&&ch.every(function(n){return n.nodeType!==1||/colo-/.test(n.className||'')}))continue;upd();return}
  }).observe(document.body,{childList:true,subtree:true});
  document.addEventListener('change',upd);window.addEventListener('resize',upd);
});
})();
